import { createFileRoute } from '@tanstack/react-router';
import { Dashboard } from '../../features/B9/dashboard';

// Home dashboard — lane B9 (mockups/assets/screens/dashboard.js).
export const Route = createFileRoute('/_app/')({
  component: Dashboard,
});
